import React, { useEffect } from 'react'
import { useChatContex } from '../../../contex/ChatContex'
import ConversationData from './ConversationData'
import { Box, styled, Divider } from '@mui/material'







const Components=styled(Box)`
height:81vh;
overflow:overlay;
`
const Deviders=styled(Divider)`
margin:0 0 0 70px;
background-color:#e9edef;
opacity:.6 ;

`








function Conversation({search}) {


const{FilterData,login,socket,SetActiveUsers,}=useChatContex()

let Data=FilterData

  let data=Data.filter((ele)=>ele.name.toLowerCase().includes(search.toLowerCase()))

  useEffect(()=>{
    socket.current.emit('addUser',login);


  },[login])

    return (
        <Components >
            {
                data.map((user)=>(
                    user.sub!==login.sub &&
                   <>
                   <ConversationData user={user}/>
                   <Deviders/>
                   </>
                ))
            }
        </Components>
    )
}

export default Conversation
